import { render, staticRenderFns } from "./VBarChart306.vue?vue&type=template&id=6530a7fe&scoped=true"
import script from "./VBarChart306.vue?vue&type=script&lang=js"
export * from "./VBarChart306.vue?vue&type=script&lang=js"
import style0 from "./VBarChart306.vue?vue&type=style&index=0&id=6530a7fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6530a7fe",
  null
  
)

export default component.exports